import { ArrayNotEmpty, IsString, IsNotEmpty, IsOptional } from 'class-validator';

export class TaxonomyReferenceItemUpdateSortRequest {
    @IsOptional()
    @IsString()
    @IsNotEmpty()
    public referenceItemParentUuid: string | null | undefined;

    @ArrayNotEmpty()
    @IsString({ each: true })
    @IsNotEmpty({ each: true })
    public referenceItemUuids: string[] = [];

    constructor(data?: Partial<TaxonomyReferenceItemUpdateSortRequest>) {
        this.referenceItemParentUuid = data?.referenceItemParentUuid;
        this.referenceItemUuids = data?.referenceItemUuids ?? [];
    }
}
